// @flow

import React from 'react';
import bemify from 'bemify-js';

import Button from 'app/common/components/Button';
import ZapMoverAccountDropdown from 'app/zap-mover/components/ZapMoverAccountDropdown';
import { Heading4 } from 'app/common/components/Heading';
import 'app/zap-mover/components/ZapMoverAccountChoosers.scss';

import type { AccountType } from 'app/zap-mover/types';

const bem = bemify('zap-mover-account-choosers');

type Props = {
  fromAccounts: Array<AccountType>,
  fromId?: number,
  toAccounts: Array<AccountType>,
  toId?: number,
  onChooseAccount: (?number, ?number) => void,
  onFlipAccounts: (?number, ?number) => void,
};

class ZapMoverAccountChoosers extends React.Component<Props> {
  onChooseFrom = (id: number) => {
    this.props.onChooseAccount(id, this.props.toId);
  };

  onChooseTo = (id: number) => {
    this.props.onChooseAccount(this.props.fromId, id);
  };

  onFlipAccounts = () => {
    const { fromId, toId, onFlipAccounts } = this.props;
    onFlipAccounts(fromId, toId);
  };

  render() {
    const { props } = this;
    return (
      <div className={bem()}>
        <section className={bem('__section')}>
          <Heading4 className={bem('__heading')}>From</Heading4>
          <ZapMoverAccountDropdown
            accounts={props.fromAccounts}
            onChooseAccount={this.onChooseFrom}
            value={props.fromId}
          />
        </section>
        <Button
          className={bem('__flipper')}
          iconBefore="flip"
          kind="secondary"
          onClick={this.onFlipAccounts}
        />
        <section className={bem('__section')}>
          <Heading4 className={bem('__heading')}>To</Heading4>
          <ZapMoverAccountDropdown
            accounts={props.toAccounts}
            onChooseAccount={this.onChooseTo}
            value={props.toId}
          />
        </section>
      </div>
    );
  }
}

export default ZapMoverAccountChoosers;
